import { apiUrl } from "../config";

export const resolveApiPath = (
  path,
  {
    environment = process.env.NODE_ENV,
    configuredApiUrl = apiUrl,
  } = {}
) => {
  if (typeof path !== "string" || !path.startsWith("/")) {
    throw new Error("Chemin API absolu requis.");
  }

  // Le proxy CRA ne s'applique qu'au développement. Le build Netlify doit
  // appeler l'origine backend configurée explicitement.
  if (environment === "production") {
    return `${String(configuredApiUrl).replace(/\/+$/, "")}${path}`;
  }

  return path;
};

export const apiPath = (path) => resolveApiPath(path);
